import type { ReactNode } from 'react';
import { longDate, diffDays } from '../../lib/dates.ts';
import { chipColor } from '../../ui/MonthGrid.tsx';

export interface AgendaEntry {
  id: string;
  date: string;
  time: string | null;
  endTime?: string | null;
  title: string;
  color: string;
  done?: boolean;
  icon?: ReactNode;
  sub?: ReactNode;
  onOpen: () => void;
}

function dayTitle(date: string, today: string) {
  const d = diffDays(date, today);
  const label = longDate(date);
  return d === 0 ? `Oggi · ${label}` : d === 1 ? `Domani · ${label}` : d === -1 ? `Ieri · ${label}` : label;
}

/** Entries grouped by day, as a list of inset cards. */
export function Agenda({ entries, today, emptyText, onAddDay }: { entries: AgendaEntry[]; today: string; emptyText?: string; onAddDay?: (date: string) => void }) {
  const days = [...new Set(entries.map((e) => e.date))].sort();
  if (!days.length) return emptyText ? <p className="hint" style={{ padding: '16px 4px' }}>{emptyText}</p> : null;
  return (
    <>
      {days.map((date) => {
        const list = entries.filter((e) => e.date === date).sort((a, b) => (a.time ?? '').localeCompare(b.time ?? ''));
        return (
          <section className="agenda-day" key={date}>
            <div className="agenda-head">
              <h3>{dayTitle(date, today)}</h3>
              <span>{list.length}</span>
              {onAddDay && <button type="button" className="btn btn-plain btn-sm" style={{ marginLeft: 'auto' }} onClick={() => onAddDay(date)}>Aggiungi</button>}
            </div>
            <div className="card list">
              {list.map((e) => (
                <button key={e.id} type="button" className="agenda-row" onClick={e.onOpen} style={{ '--chip': chipColor(e.color) } as React.CSSProperties}>
                  <span className="bar" />
                  <span className="time">{e.time ?? '—'}</span>
                  <span className="grow">
                    <div className="title" style={e.done ? { textDecoration: 'line-through', color: 'var(--label-3)' } : undefined}>{e.title}</div>
                    {e.sub && <div className="sub">{e.sub}</div>}
                  </span>
                  {e.icon && <span className="kind-icon">{e.icon}</span>}
                </button>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
